import { GameData } from '../game-data.js';
import ResourceVector from "../resource-vector.js";
import ShipStatsVector from "../ship-stats-vector.js";

export default class ShipCostFormulas {
    static getShipBuildCost(config) {
        let result = new ResourceVector().init();
        for (let i = 0; i < GameData.TECHNOLOGIES.length; i++) {
            let tech = GameData.TECHNOLOGIES[i];
            if (config[tech.id] > 0) {
                let cost = tech.build_cost;
                let scaled_cost = new ResourceVector().initSparse(cost).scaleVectorSparse(config[tech.id]);
                result.addVectorSparse(result, scaled_cost);
            }
        }
        return result.floor();
    }

    static getShipDesignCost(config) {
        const result = ShipCostFormulas.getShipBuildCost(config);
        result.powSparse(1.2);
        return result.floor();
    }

    static _getShipConstructionEffort(config) {
        return GameData.TECHNOLOGIES.reduce((acc, tech) => {
            if (!config[tech.id]) return acc;
            return acc + config[tech.id] * tech.build_time;
        }, 0) * 10;
    }

    static getShipBuildTime(config, ship_factory_level) {
        const time = ShipCostFormulas._getShipConstructionEffort(config) * GameData.MINUTE / ship_factory_level / GameData.SPEED;
        return Math.ceil(time);
    }

    static getShipDesignTime(config, ship_factory_level) {
        const build_time = ShipCostFormulas.getShipBuildTime(config, ship_factory_level) * 5;
        return Math.ceil(build_time);
    }

    static getAcceleration(ship_stats) {
        if (!ship_stats.thrust || !ship_stats.structure) return 0;
        return Math.floor(Math.pow(ship_stats.thrust, 1.5) / ship_stats.structure);
    }
}